import { DELIVERY_PROJECT_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: DELIVERY_PROJECT_MNG,
  needFetchFillInfo: false,
  callBackAction: 'CreateDdProjectSuccessBack',
  params: null,
  formatData(data) {
    // data.salesId = data.salesIdLabel.id
    if (data.presalesIdLabel) {
      data.presalesId = data.presalesIdLabel.id
    }
    // data.salesLeader = data.salesLeaderLabel.id
    data.salesLeaderIdList = []
    data.salesLeaderLabelList.forEach(item => {
      data.salesLeaderIdList.push(item.id)
    })
    data.postsalesIdList = []
    data.postsalesIdLabelList.forEach(element => {
      data.postsalesIdList.push(element.id)
    })
    if (data.templateProjectIdLabel) {
      data.templateProjectId = data.templateProjectIdLabel.id
    }
    return data
  },
  view: {
    title: 'deliveryMng.createBaseDdProject',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '650px',
    content: [
      {
        $id: 'industryId',
        $type: 'radio-button',
        label: 'pocMng.industry',
        $default: null,
        params: {
          unPage: true
        },
        $el: {
          class: 'wsp-custom-edit-industry-disabled',
          disabled: true
        },
        $options: [],
        rules: [
          {
            notEmpty: 'pocMng.industryEmpty'
          }
        ]
      },
      {
        $id: 'projectName',
        $type: 'input',
        label: '项目名称',
        $el: { disabled: true },
        rules: [
          {
            notEmpty: '项目名称'
          }
        ]
      },
      {
        $id: 'customer',
        $type: 'input',
        label: 'pocMng.customer',
        rules: [
          {
            notEmpty: 'pocMng.customer'
          }
        ]
      },
      {
        $id: 'presalesIdLabel',
        $type: 'sky-relation-option',
        label: 'pocMng.presales',
        $el: { disabled: false },
        actions: {
          nativeOn: {
            click: 'UmRelationUser'
          }
        }
        // rules: [{ notEmpty: { message: 'pocMng.presalesEmpty' } }]
      },
      {
        $id: 'salesLeaderLabelList',
        $type: 'sky-relation-option',
        label: '管理者',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesEmpty' } }]
      },
      {
        $id: 'postsalesIdLabelList',
        $type: 'sky-relation-option',
        label: 'pocMng.postsales',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'UmRelationUserList'
          }
        },
        rules: [{ notEmpty: { message: 'pocMng.postsalesEmpty' } }]
      },
      {
        $id: 'contractNo',
        $type: 'input',
        label: '合同编号',
        $el: { disabled: true },
        rules: [
          {
            notEmpty: '合同编号'
          }
        ]
      },
      {
        $id: 'startTime',
        $type: 'datePicker',
        $el: {
          type: 'date'
        },
        label: 'pocMng.startTime',
        rules: [
          {
            notEmpty: 'pocMng.startTimeEmpty'
          }
        ]
      },
      {
        // 隐藏字段信息
        $id: 'productName',
        $type: 'sky-form-value',
        label: '部署产品包',
        $el: { disabled: true, defaultValue: 'xxxxxx' }
      },
      {
        // 隐藏字段信息
        $id: 'productList',
        $type: 'sky-delivery-deploy-product',
        label: '项目设备清单'
      }
    ]
  }
}
